<div
  class="producer-bg"
  [ngStyle]="{
    'background-image': producerCover ? 'url(' + producerCover + ')' : 'url(' + (producerDefaultCover | bmAssetUrl) + ')'
  }"
>
  @if (producerLogo) {
    <img class="producer-bg__logo" src="{{ producerLogo }}" alt="logotype" />
  }
  <div class="producer-bg__container"></div>
</div>
